export default {
  "fontElementMap": "WrFa3",
  "wrapper": "M4zTR",
  "pluginContainerMobile": "_8Ea50",
  "viewer": "IdchG",
  "android": "BUQTH",
  "rootedTraversedContent": "OWEgq",
  "atomic": "ZL8rf",
  "toolbar": "MZGeE",
  "block": "Jza3-"
};